import { InteractionType, } from '@debbie/common/dist/interactions/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { APIBASE } from '../../config.js';
import THEME from '../../theme.js';
import { FileText } from '../Icons/index.js';
import { Modal } from '../index.js';
import ObjectComp from '../ObjectComp.js';
import DefaultSummary from './DefaultSummary.js';
const LetterSummary = (props) => {
    const [open, setOpen] = useState(false);
    const interaction = props.interaction;
    if (interaction.type !== InteractionType.Letter) {
        throw new Error('Interaction is not of type Letter');
    }
    const letter = props.interaction.details;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(DefaultSummary, { transparrent: !open, ...props },
        React.createElement(ShowPDFButton, { onClick: () => setOpen(!open) },
            React.createElement(FileText, { size: 14 }),
            lang.interactions.seeDocument),
        open && (React.createElement(Modal, { header: lang.interactionTypes.LETTER, onToggle: () => {
                setOpen(!open);
            } },
            React.createElement(ObjectComp, { type: "application/pdf", url: `${APIBASE}/files/${letter.pdf}/debbie.pdf` })))));
};
export default LetterSummary;
const ShowPDFButton = styled.p `
  background: none;
  border: none;
  cursor: pointer;
  color: ${THEME.COLOR_ACCENT};
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.85em;
  padding: 0;
  margin: 0;

  &:hover {
    text-decoration: underline;
  }
`;
//# sourceMappingURL=LetterSummary.js.map